.degraded-quality-indicator button {
  padding: 0.1rem;
}
.degraded-quality-indicator svg {
  margin-top: -1px;
  margin-left: 2px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvVmlzdWFsaXphdGlvbi92aXN1YWxpemF0aW9ucy9sYXN0VmFsdWUvc2hhcmVkL0RlZ3JhZGVkUXVhbGl0eUluZGljYXRvciIsInNvdXJjZXMiOlsiRGVncmFkZWRRdWFsaXR5SW5kaWNhdG9yLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRTs7QUFHRjtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuZGVncmFkZWQtcXVhbGl0eS1pbmRpY2F0b3Ige1xuICBidXR0b24ge1xuICAgIHBhZGRpbmc6IDAuMXJlbTtcbiAgfVxuXG4gIHN2ZyB7XG4gICAgbWFyZ2luLXRvcDogLTFweDtcbiAgICBtYXJnaW4tbGVmdDogMnB4O1xuICB9XG59XG4iXX0= */